module.exports = __webpack_public_path__ + "static/media/NP.2a416f9c.png";